import { ArgsType } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../base/baseGetById.args'

@ArgsType()
export class BookGetByIdArgs extends BaseGetByIdArgs<BookGetByIdArgs> { }
